import AppointmentDay from "./AppointmentDay";

export default AppointmentDay;